<template>
  <div class="page" v-loading="loading">
<!--    删除  deleteBtn-->
<!--    批量删除  BatchDelete-->
    <el-form label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="模板名称">
            <el-input v-model="searchData.name" clearable placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="状态">
            <el-select v-model="searchData.isActive" clearable class="w100">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="启用" :value="true"></el-option>
              <el-option label="禁用" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="创建时间">
            <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker" class="w100">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <div class="flex">
          <el-button type="primary" @click="searchFun">查询</el-button>
          <el-button @click="resetFun">重置</el-button>
          <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
        </div>
      </el-form-item>
    </el-form>
    <div>
      <el-table border :data="tableList" @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <el-table-column label="模板名称" prop="name" align="center" width="200"></el-table-column>
        <el-table-column label="关联类型" prop="categoryName" align="center" min-width="200"></el-table-column>
        <el-table-column label="状态" align="center" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.isActive">启用</span>
            <span v-else>禁用</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="creationTime" align="center" width="200"></el-table-column>
        <el-table-column label="操作" align="center" width="300">
          <template slot-scope="scope">
            <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
              @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]" class="pagination">
      </el-pagination>
    </div>
    <!-- 新增模板 -->
    <el-dialog title="新增模板" :visible.sync="dialogVisibleAdd">
      <el-form class="dialog-box" label-width="130px" :model="addForm" :rules="addFormRules" ref="addForm">
        <el-form-item label="模板名称：">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
<!--        <el-form-item label="选择关联类型：" prop="categoryId">-->
<!--          <el-cascader v-model="addForm.categoryId" :props="{ emitPath: false }" :show-all-levels="true"-->
<!--            :options="categoryTreeList" placeholder="请选择类型" @change="handleSelType" style="width: 70%"></el-cascader>-->
<!--        </el-form-item>-->
        <el-form-item label="状态：">
          <el-switch v-model="addForm.isActive" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addCancel">取消</el-button>
        <el-button type="primary" @click="submitFun">新增</el-button>
      </div>
    </el-dialog>
    <!-- 模板编辑 -->
    <el-dialog title="模板编辑" :visible.sync="dialogVisibleEdit">
      <el-form class="dialog-box" label-width="120px">
        <el-form-item label="模板名称：">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
<!--        <el-form-item label="类型名称：">-->
<!--          <el-cascader v-model="editForm.categoryId" :props="{ emitPath: false }" :show-all-levels="true"-->
<!--            :options="categoryTreeList" placeholder="请选择类型" @change="handleSelType2" style="width: 70%"></el-cascader>-->
<!--        </el-form-item>-->
        <el-form-item label="状态：">
          <el-switch v-model="editForm.isActive" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editCancel">取消</el-button>
        <el-button type="primary" @click="submitEditFun">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getButtonList } from "../../../promissionRouter";
import toolbar from "../../../components/Toolbar";
import {
  CategoryGetTree,
  PropertyGroupCreate,
  PropertyGroupDelete,
  PropertyGroupUpdate,
  PropertyGroupGetAll,
  PropertyGroupGet
} from '../../../api/api'
export default {
  components: {
    toolbar
  },
  data() {
    return {
      dialogVisibleAdd: false,
      dialogVisibleEdit: false,
      buttonList_toolBar: [],
      buttonList_table: [],
      valueTime: [],
      total: 0,
      tableList: [],
      searchData: {
        name: null,
        isActive: null,
        beginCreateTime: null,
        endCreateTime: null,
        skipCount: 0,
        maxResultCount: 10
      },
      pageIndex: 1,
      pageSize: 10,
      categoryTreeList: [],
      typeIdList1: [],
      typeIdList2: [],
      addForm: {
        name: '',
        categoryId: 0,
        isActive: true
      },
      editForm: {
        name: '',
        categoryId: 0,
        isActive: true
      },
      checkList: [],

      addFormRules: {
        categoryId: [
          { required: true, message: '请选择关联类型', trigger: 'change' }
        ]
      },
      loading: false
    }
  },
  created() {
    this.getTableData()
    this.getTypeList()
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    const toolBarButtonList = buttonList.filter((item) => {
      return item.buttonShow === 10;
    });
    this.buttonList_toolBar = toolBarButtonList;

    const tableButtonList = buttonList.filter((item) => {
      return item.buttonShow === 20;
    });
    this.buttonList_table = tableButtonList;
  },
  methods: {
    handleSelectionChange(val) {
      this.checkList = val
    },
    BatchDelete() {
      if (!this.checkList[0]) {
        return this.$message.error('请选择模板！')
      }
      let list = []
      list = this.checkList.map(item => {
        return item.id
      })
      PropertyGroupDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getTableData()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    searchFun() {
      this.pageIndex = 1
      this.getTableData()
    },
    resetFun() {
      this.searchData = {
        name: null,
        isActive: null,
        beginCreateTime: null,
        endCreateTime: null,
        skipCount: 0,
        maxResultCount: 10
      }
      this.pageIndex = 1
      this.pageSize = 10
      this.valueTime = []
      this.getTableData()
    },
    handlePicker(date) {
      if (date == null) {
        this.valueTime = []
        this.searchData.beginCreateTime = null
        this.searchData.endCreateTime = null
      } else {
        this.searchData.beginCreateTime = date[0]
        this.searchData.endCreateTime = date[1]
      }
    },
    getTableData() {
      this.loading = true
      this.searchData.skipCount = (this.pageIndex - 1) * this.pageSize
      this.searchData.maxResultCount = this.pageSize
      PropertyGroupGetAll(this.searchData).then(res => {
        if (res.data.success) {
          this.tableList = res.data.result.items
          this.total = res.data.result.totalCount
        } else {
          this.$message.error(res.data.error.message)
        }
        setTimeout(() => {
          this.loading = false
        }, 500)
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getTableData()
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    editTemplate(item, index, row) {
      // PropertyGroupGet({id: row.id}).then(res => {
      PropertyGroupGet({ id: row.id }).then(res => {
        if (res.data.success) {
          this.dialogVisibleEdit = true
          this.editForm = res.data.result
          // this.typeIdList2 = res.data.result.categoryId
          // console.log(this.typeIdList2,'this.typeIdList2')
        }
      })
    },
    addTemplate() {
      this.dialogVisibleAdd = true
    },
    addCancel() {
      this.dialogVisibleAdd = false
      this.addForm = {
        name: '',
        // categoryId: 0,
        isActive: true
      }
    },
    editCancel() {
      this.dialogVisibleEdit = false
      this.editForm = {
        name: '',
        categoryId: 0,
        isActive: true
      }
    },
    submitFun() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            this.addForm.categoryId = 0;
            PropertyGroupCreate(this.addForm).then(res => {
              if (res.data.success) {
                this.dialogVisibleAdd = false
                this.getTableData()
                this.addForm = {
                  name: '',
                  categoryId: 0,
                  isActive: true
                }
                this.$message.success('提交成功')
              } else {
                this.$message.error(res.data.error.message)
              }
            })
          }).catch(() => { });
        }
      });
    },
    submitEditFun() {
      this.editForm.categoryId = 0;
      PropertyGroupUpdate(this.editForm).then(res => {
        if (res.data.success) {
          this.dialogVisibleEdit = false
          this.getTableData()
          this.editForm = {
            id: null,
            name: '',
            categoryId: 0,
            isActive: true
          }
          this.$message.success('提交成功')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    handleSelType(data) {
      debugger
      let test = 1;
      // console.log(data)
      // this.addForm.categoryId = data[data.length-1]
    },
    handleSelType2(data) {
      // console.log(data, this.editForm.categoryId)
      // this.editForm.categoryId = data[data.length-1]
    },
    getTypeList() {
      CategoryGetTree({ parentId: 0, isActive: true }).then(res => {
        this.categoryTreeList = this.loopMenuTree(res.data.result.children)
      })
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    deleteBtn(item, index, row) {
      PropertyGroupDelete({ ids: [row.id] }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getTableData()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    maintainBtn(item, index, row) {
      this.$router.push(`/Product/AttributeTemplate/Maintain?groupId=${row.id}`)
    }
  }
}
</script>

<style scoped>
.attribute {
  padding: 0 20px;
}

.dialog-box .el-input {
  width: 400px;
}
</style>
